module.exports = __webpack_public_path__ + "static/img/perview.04ce04f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/perview.png
// module id = kIV5
// module chunks = 1